import { api } from "@/configs/axios";

export type GetActiveCampaignResponse = {
  id: string
  title: string
  value: number
  count: number
}

export class CampaignService {
  async getActive() {
    const { data } = await api.get<GetActiveCampaignResponse>("/campaigns/active")

    return data
  }
}

export const campaignServiceInstance = new CampaignService()